import {} from '../../../shared/types';
import {
  ExternalPricingSheetItem,
  PostPricingSheetItems,
  PricingSheetItemResponse,
} from '../../../shared/types/pricingSheetItems';
import { api } from '../index';

export const postPricingSheetItems = (
  pricingSheetItems: PostPricingSheetItems[],
) => {
  const postPricingSheetItemsResponse = api
    .post(`/pricing-sheet-items`, {
      pricingSheetItems: pricingSheetItems,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return postPricingSheetItemsResponse;
};

export const putPricingSheetItems = (
  pricingSheetId: string,
  pricingSheetItems: PostPricingSheetItems[],
) => {
  const putPricingSheetItemsResponse = api
    .put(`/pricing-sheet-items`, {
      pricingSheetId,
      pricingSheetItems: pricingSheetItems,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return putPricingSheetItemsResponse;
};

export const deletePricingSheetItems = (
  pricingSheetId: string,
  itemIds: string[],
) => {
  const queryParams = itemIds
    .map((itemId) => `itemId=${itemId}`)
    .join('&');
  const deletePricingSheetItemsResponse = api
    .delete(`/pricing-sheet-items/${pricingSheetId}?${queryParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return deletePricingSheetItemsResponse;
};

export const getPricingSheetItemsById = async (id: string) => {
  const getPricingSheetItemsByIdResponse = await api.get<
    PricingSheetItemResponse[]
  >(`/pricing-sheet-items/${id}`);
  return getPricingSheetItemsByIdResponse.data;
};

export const addCommentToPricingSheetItemById = (
  id: string,
  pricingSheetItem: { approverComment?: string; catClass?: string },
) => {
  const commentToPricingSheetResponse = api
    .put(`/pricing-sheet-items/${id}`, pricingSheetItem)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return commentToPricingSheetResponse;
};

export const getPricingSheetItemsMira = async (
  id: string,
  onlyRamiturvas = false,
) => {
  const getItemsResponse = await api.get<ExternalPricingSheetItem[]>(
    `/pricing-sheet-items/mira/${id}?onlyRamiturvas=${onlyRamiturvas}`,
  );
  return getItemsResponse.data;
};
